import * as React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { RouteComponentProps } from 'react-router-dom';

import { IQmDokumentationResponse } from '../../models/ApiTypes';
import { ApiStore } from '../../stores/ApiStore';
import { bind, inject } from '../../utils/decorators';
import { QmListe } from './QmListe';

@observer
export default class QmDokumentation extends React.Component<RouteComponentProps<{}>, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @observable qmDoku?: IQmDokumentationResponse;

  @action setQmDoku(qmDoku: IQmDokumentationResponse) {
    this.qmDoku = qmDoku;
  }

  @action clearAuftraege() {
    this.qmDoku = undefined;
  }

  componentDidMount() {
    this.ladeQmDokumentation();
  }

  async ladeQmDokumentation() {
    let qmDoku = await this.apiStore.qmdokumentation();
    if (qmDoku.ok) {
      this.setQmDoku(qmDoku.json);
    }
  }

  @bind async handleDokumentClick(befugnis: string, dateiname: string) {
    const downloadLink = await this.apiStore.qmDokumentDownloadUrl(befugnis, dateiname);
    window.open(downloadLink);
  }

  render() {
    return (
      <div className="qm-dokumentation maxwidth">
        <h2>Freigegebene QM-Dokumente</h2>
        {!this.qmDoku ? <div>lade QM-Dokumentation...</div> : (
          <div>
            {(this.qmDoku.length === 0) ?
              <div>Es wurden noch keine QM-Dokumente freigegeben</div> :
              this.qmDoku.map((element, index) =>
                <QmListe
                  key={index}
                  expanded={true}
                  befugnis={element.befugnis}
                  dokumente={element.dokumente}
                  handleEintragClick={this.handleDokumentClick}
                />
              )
            }
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/user/QmDokumentation.tsx